import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as Service from '../services';
import makeData from '../services/makeData';
import { GENERAL } from '../config/Transaction/ProductGeneralConf';


import { COLUMNS } from '../config/Transaction/columns';
import { addAfterLoginNotification } from '../../../components/Toast/utils/notifications';

interface AsyncState {
  isLoading: {
    offerData: boolean;
    brandsData: boolean;
    offerAdd: boolean;
    deleteOffer: boolean;
  };
  isSuccess: boolean;
  isError: boolean;
}

interface TableState extends AsyncState {
  offerData: any;
  totalCount: Number;
  statusData: any;
  applicationOptions: any;
  addOfferRes: any;
  editProductRes: any;
  deleteBrandRes: any;
  isLogout: any;
  fullResponse: Array<any>;
  brandsData: Array<any>;
  rootReducer?: any;
  auth?: any;
  errorMsg?: any;
  userTableColumns: any,

}

const initialState: TableState = {
  isLoading: {
    offerData: true,
    brandsData: true,
    offerAdd: false,
    deleteOffer: false,
  },
  isSuccess: false,
  isError: false,
  offerData: null,
  statusData: null,
  applicationOptions: null,
  addOfferRes: {},
  editProductRes: null,
  deleteBrandRes: null,
  totalCount: NaN,
  isLogout: false,
  fullResponse: [],
  brandsData: [],
  errorMsg: null,
  userTableColumns: COLUMNS,
};




export const fetchAllOffers = createAsyncThunk('offerData', async (data: any, thunkAPI) => {
  try {
    const res: any = await Service.getAllOffer();

    const madeData = makeData(res.data);

    return { madeData, totalCount: res.totalCounts, fullResponse: res.data };
  } catch (error: any) {
    // thunkAPI.dispatch(resetLogout(error))
    return thunkAPI.rejectWithValue(error);
  }
});


export const addOffer = createAsyncThunk('user/addBrandData', async (data: any, thunkAPI) => {
  try {
    return await Service.addOffer(data);
  } catch (error) {
    // thunkAPI.dispatch(resetLogout(error));
    return thunkAPI.rejectWithValue(error);
  }
});

export const deleteOffer = createAsyncThunk('user/deleteOffer', async (data: any, thunkAPI) => {
  try {
    return await Service.deleteOffer(data);
  } catch (error) {
    // thunkAPI.dispatch(resetLogout(error));
    return thunkAPI.rejectWithValue(error);
  }
});


export const getColumns = createAsyncThunk('getColumns', (data: any, thunkAPI) => {
  try {
    // const madeColsData = makeData(data);
    return data?.cols;
  } catch (error) {
    // thunkAPI.dispatch(resetLogout(error));
    return thunkAPI.rejectWithValue(error);
  }
});


export const offerSlice = createSlice({
  name: 'offers',
  initialState,
  reducers: {
    resetAddOfferRes: (state) => {
      state.addOfferRes = {};
    },
  },
  extraReducers: (builder) => {
    builder
      //Obtaining data
      .addCase(fetchAllOffers.pending, (state, action: any) => {
        state.isLoading.offerData = true;
        state.isError = false;
        state.errorMsg = null;
      })
      .addCase(fetchAllOffers.fulfilled, (state, action: any) => {
        state.isLoading.offerData = false;
        state.isSuccess = true;
        state.isError = false;
        state.offerData = action.payload.madeData;
        state.totalCount = action.payload.totalCount;
        state.fullResponse = action.payload.fullResponse;
        state.errorMsg = null;
      })
      .addCase(fetchAllOffers.rejected, (state, action: any) => {
        state.isLoading.offerData = false;
        state.isError = true;
        state.errorMsg = action.payload.errorMsg;
        state = {
          ...state,
          ...action.payload
        }

      })

      .addCase(addOffer.pending, (state) => {
        state.isLoading.offerAdd = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMsg = null;
        state.addOfferRes = null;
      })
      .addCase(addOffer.fulfilled, (state, action: any) => {
        addAfterLoginNotification('Offer Create successfully', "success");
        state.isLoading.offerAdd = false;
        state.isSuccess = true;
        state.isError = false;
        state.addOfferRes = action.payload ?? {};
      })
      .addCase(addOffer.rejected, (state, action: any) => {
        addAfterLoginNotification(action.payload.errorMsg, "error");
        state.isLoading.offerAdd = false;
        state.isSuccess = false;
        state.isError = true;
        state.addOfferRes = null;
        state.errorMsg = action.payload.errorMsg;
      })


      // MODIFY_COLUMNS
      .addCase(getColumns.pending, (state) => {
        // state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.userTableColumns = initialState.userTableColumns;
      })
      .addCase(getColumns.fulfilled, (state, action: any) => {
        // state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.userTableColumns = action.payload;
      })
      .addCase(getColumns.rejected, (state) => {
        // state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.userTableColumns = initialState.userTableColumns;
      })

      .addCase(deleteOffer.pending, (state) => {
        state.isLoading.deleteOffer = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMsg = null;
        state.deleteBrandRes = null;
      })
      .addCase(deleteOffer.fulfilled, (state, action: any) => {
        addAfterLoginNotification('Offer Deleted successfully', "success");
        state.isLoading.deleteOffer = false;
        state.isSuccess = true;
        state.isError = false;
        state.deleteBrandRes = action.payload;
      })
      .addCase(deleteOffer.rejected, (state, action: any) => {
        addAfterLoginNotification(action.payload.errorMsg, "error");
        state.isLoading.deleteOffer = false;
        state.isSuccess = false;
        state.isError = true;
        state.deleteBrandRes = null;
        state.errorMsg = action.payload.errorMsg;
      })


  },
});
export const { resetAddOfferRes } = offerSlice.actions;
export default offerSlice.reducer;
